import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from '../fragments/document.fragments';

export const CREATE_DOCUMENT = gql`
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      document {
        ...documentValues
      }
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateDocument($id: UUID!, $input: UpdateDocumentInput!) {
    updateDocument(id: $id, input: $input) {
      document {
        ...documentValues
      }
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export const DELETE_DOCUMENTS = gql`
  mutation DeleteDocument($ids: [UUID]!) {
    deleteDocument(ids: $ids) {
      ids
    }
  }
`;
